import { render, staticRenderFns } from "./logisticsOrderDetail.vue?vue&type=template&id=38536380&scoped=true"
import script from "./logisticsOrderDetail.vue?vue&type=script&lang=js"
export * from "./logisticsOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./logisticsOrderDetail.vue?vue&type=style&index=0&id=38536380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38536380",
  null
  
)

export default component.exports